/**
 * Virgo protected action types
 */
const successAndFailure = ['FAILURE', 'SUCCESS'];
function asyncType(name) {
  return [name, ...successAndFailure.map(value => `${name}_${value}`)];
}

const types = {
  ALERT: [
    'SET',
    'UNSET',
  ],

  DATA: [
    ...asyncType('FETCH'),
    'UPDATE',
    'DELETE',
  ],

  FEED: [
    'INVALIDATE',
    'RESET',
    ...asyncType('REQUEST'),
  ],

  FOLLOW: [
    ...asyncType('TOGGLE'),
  ],

  IMAGE: [
    'UPLOADED',
  ],

  LOG: [
    ...asyncType('IN'),
    ...asyncType('FACEBOOK'),
    ...asyncType('OUT'),
  ],

  SIGN: [
    ...asyncType('UP'),
  ],

  LOCAL_STATE: [
    'GROUP_SEARCH_FILTER',
    'CONTENT_SEARCH_FILTER',

    'TYPE_RESPONSE',
    'CLEAR_RESPONSE',
  ],

  MESSAGE: asyncType('SEND'),

  COUNTER: [
    'READ',
    ...asyncType('UNREAD'),
  ],

  POST: [
    ...asyncType('SEND'),
    ...asyncType('EDIT'),
    'COMPOSE',
    ...asyncType('COMPOSE_UPLOAD_IMAGE'),
    ...asyncType('TOGGLE_RATE'),
    ...asyncType('RESPOND'),
    ...asyncType('REPORT'),
    ...asyncType('DELETE'),
    ...asyncType('TOGGLE_LOCK'),
    ...asyncType('TOGGLE_PIN'),
  ],

  PROFILE: [
    ...asyncType('UPDATE'),
    ...asyncType('AVATAR_UPDATE'),
    ...asyncType('UNSUBSCRIBE'),
    ...asyncType('DELETE'),
  ],

  REGISTER: [
    ...asyncType('EMAIL'),
    ...asyncType('FACEBOOK'),
  ],

  THREAD: [
    'CREATE',
    'DELETE',
    ...asyncType('CHANGE_PARTICIPANTS'),
    'READ',
    ...asyncType('CHANGE_SUBJECT'),
    ...asyncType('MARK_AS_READ'),
    ...asyncType('BULK_DELETE'),
    ...asyncType('UNDO_BULK_DELETE'),
  ],

  USER: [
    ...asyncType('RESTRICT'),
  ],
};

const result = {};
Object.entries(types).forEach(([key, values]) => {
  values
    .map(value => `${key}_${value}`)
    .forEach(name => result[name] = name);
});

export default result;



// WEBPACK FOOTER //
// ./~/virgo/src/actions/actionTypes.js